import { ReactElement } from "react";
import { ControllerRenderProps, FieldValues, Path } from "react-hook-form";

import { BaseFormFieldProps } from "./form-field-wrapper";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui";

export interface CustomFormFieldWithChildProps<T extends FieldValues>
  extends BaseFormFieldProps<T> {
  renderChild: (field: ControllerRenderProps<T, Path<T>>) => ReactElement;
}
export const CustomFormFieldWithChild = <T extends FieldValues>({
  renderChild,
  control,
  name,
  label,
  required,
  description,
}: CustomFormFieldWithChildProps<T>) => {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem>
          {label && (
            <FormLabel className="w-full">
              {label} {required && <span className="text-destructive">*</span>}
            </FormLabel>
          )}
          <FormControl>{renderChild(field)}</FormControl>
          {description && <FormDescription>{description}</FormDescription>}
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
